import * as domUtil from '../../util/dom';
import * as videoAttributes from '../../util/video-attributes';
import { renderCues } from '../vtt';

const CAPTIONS_STORAGE_KEY = 'captionsOn';
const NAMESPACE = 'dashsubtitles';
const fullscreenEvents = 'fullscreenchange, mozfullscreenchange, MSFullscreenChange, webkitfullscreenchange';

const getCurrentInstanceNamespace = (videoElement) => {
    const uid = videoAttributes.getUID(videoElement) || videoAttributes.generateAndSetUID(videoElement);

    return `${NAMESPACE}-${uid}`;
};

export default class DashSubtitles {
    constructor(videoElement, mediaPlayer, api, dashjs) {
        this.videoElement = videoElement;
        this.mediaPlayer = mediaPlayer;
        this.api = api;
        this.instanceNamespace = getCurrentInstanceNamespace(videoElement);

        this.enabled = false;

        this.ttmlElement = document.createElement('div');
        this.ttmlElement.className = 'ttml-captions';
        this.mediaPlayer.attachTTMLRenderingDiv(this.ttmlElement);
        this.api.element().appendChild(this.ttmlElement);

        this.vttElement = document.createElement('div');
        this.vttElement.className = 'vtt-captions';
        this.api.element().appendChild(this.vttElement);

        this.visible = domUtil.getStoredData(CAPTIONS_STORAGE_KEY) === 'true';

        mediaPlayer.on(dashjs.MediaPlayer.events.TEXT_TRACKS_ADDED, (e) => {
            this.enabled = true;
            if (this.visible) {
                this.show();
            } else {
                this.hide();
            }

            domUtil.addEvents(this.videoElement.textTracks[0], 'cuechange', this._onCueChange.bind(this), NAMESPACE);
            this.api.fire('captionsloaded', { fromManifest: true });
        });

        this.api.on('subtitles.controls', this._onControls.bind(this));

        domUtil.addEvents(window, 'resize', this._onSizeChanged.bind(this), this.instanceNamespace);
        domUtil.addEvents(document, fullscreenEvents, this._onSizeChanged.bind(this), this.instanceNamespace);
    }

    isEnabled() {
        return this.enabled;
    }

    show() {
        this.visible = true;

        const textTracks = this.videoElement.getTextTracks();
        if (textTracks.length > 0) {
            if (textTracks[0].mimeType === 'text/vtt') {
                this.videoElement.textTracks[0].mode = 'hidden';
                this.vttElement.style.display = 'block';
            } else {
                this.mediaPlayer.setTextTrack(0);
            }
        }
    }

    hide() {
        this.visible = false;

        const textTracks = this.videoElement.getTextTracks();
        if (textTracks.length > 0) {
            if (textTracks[0].mimeType === 'text/vtt') {
                this.videoElement.textTracks[0].mode = 'disabled';
                this.vttElement.style.display = 'none';
            } else {
                this.mediaPlayer.setTextTrack(-1);
            }
        }
    }

    _onControls(controlsEvent) {
        if (controlsEvent.detail.visible) {
            this.ttmlElement.classList.add('elevated');
            this.vttElement.classList.add('elevated');
        } else {
            this.ttmlElement.classList.remove('elevated');
            this.vttElement.classList.remove('elevated');
        }
    }

    _onCueChange(cueEvent) {
        const textTracks = this.videoElement.getTextTracks();
        if (textTracks.length > 0 && textTracks[0].mimeType === 'text/vtt') {
            const activeCues = cueEvent.target.activeCues;
            renderCues(this.vttElement, cueEvent.target.activeCues);
        }
    }

    _onSizeChanged() {
        if (!this.vttElement) {
            return;
        }

        const fontSize = Math.max(this.videoElement.offsetWidth * 0.0375, 15);
        this.vttElement.style.fontSize = `${fontSize}px`;
    }

    detach() {
        this.api.off('subtitles.controls');
        this.api.element().removeChild(this.ttmlElement);
        this.api.element().removeChild(this.vttElement);
        this.enabled = false;
        this.mediaPlayer.off(dashjs.MediaPlayer.events.TEXT_TRACK_ADDED, this._onTextTrackAdded);
    }
}



// WEBPACK FOOTER //
// ./src/js/modules/dash/dash-subtitles.js